import person from "../src/Assets/User-main-img.png";

const { name, version } = require("../package.json");

export const envConfig = {
  ENV_NAME: process.env.REACT_APP_ENV,
  APP_NAME: name,
  APP_VERSION: version,
  APP_PLATFORM: "WEB",
  APPLE_APP_STORE:
    "https://apps.apple.com/us/app/walking-on-earth-wone/id1544768613?l=en",
  GOOGLE_PLAY_STORE:
    "https://play.google.com/store/apps/details?id=com.walkingonearth.app&pli=1",
  //DEVELOPMENT
  //uri: process.env.REACT_APP_API_URL,

  /* API_URL: 'http://18.130.180.166/graphql/',
    FILE_UPLOAD_URL: 'http://18.130.180.166/', */

  APP_DOMAIN: process.env.REACT_APP_DOMAIN,
  WEBSITE_URL: process.env.REACT_APP_WEBSITE_URL,
  API_URL: process.env.REACT_APP_API_URL,
  FILE_UPLOAD_URL: process.env.REACT_APP_UPLOAD_URL,
  COACH_URL: process.env.REACT_APP_COACH_URL,
  PLATFORM_ENV: process.env.REACT_APP_PLATFORM_ENV,
  WONE_DATA_EVENTS_URL: process.env.REACT_APP_WONE_DATA_EVENTS_URL,
  WONE_DATA_API_KEY: process.env.REACT_APP_WONE_DATA_API_KEY,
  WONE_MEMBERSHIP: "https://demo.walkingonearth.com/",
  // DEVELOPMENT

  //PRODUCTION

  // API_URL: 'https://api.prod.walkingonearth.com/graphql/',
  // FILE_UPLOAD_URL: 'https://api.prod.walkingonearth.com/',

  //PRODUCTION

  PERSON_PLACEHOLDER_IMAGE: person,
  APP_ID: "c4957e88819947f98ca6aa64ebabb124", // web
  //APP_ID: '05df8ab6bce2452584d2fa95a47e917a', // android

  SELF_SERVE_MAX_NUMBER_OF_SEATS: 100,
  SELF_SERVE_CONTACT_SALES_URL:
    "https://plans.walkingonearth.com/join-gbp#choose-plan",

  PRIVACY_POLICY_URL: "https://www.walkingonearth.com/privacy-policy",
  TERMS_URL: "https://www.walkingonearth.com/terms-of-use",

  FIREBASE_API_KEY:
    process.env.REACT_APP_FIREBASE_API_KEY ??
    import.meta.env.VITE_FIREBASE_API_KEY,
  FIREBASE_APP_DOMAIN:
    process.env.REACT_APP_FIREBASE_APP_DOMAIN ??
    import.meta.env.VITE_FIREBASE_APP_DOMAIN,
  FIREBASE_DATABASE_URL:
    process.env.REACT_APP_FIREBASE_DATABASE_URL ??
    import.meta.env.VITE_FIREBASE_DATABASE_URL,
  FIREBASE_PROJECT_ID:
    process.env.REACT_APP_FIREBASE_PROJECT_ID ??
    import.meta.env.VITE_FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ??
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGING_SENDER_ID:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ??
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID:
    process.env.REACT_APP_FIREBASE_APP_ID ??
    import.meta.env.VITE_FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID ??
    import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,

  SENTRY_DNS: process.env.REACT_APP_SENTRY_DNS,
  AWS_ACCESS_KEY_ID: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  AWS_SECRET_ACCESS_KEY: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  AWS_REGION: process.env.REACT_APP_AWS_REGION,
  BRANCH_KEY: process.env.REACT_APP_BRANCH_KEY,
  MIXPANEL_TOKEN: process.env.REACT_APP_MIXPANEL_TOKEN,
};
export default envConfig;
